<div class="user-area d-flex" *ngIf="userInfo || isDependent()" [ngStyle]="styles">
  <!--  Visão desktop: Mostra do md pra cima -->
  <div class="d-none d-md-grid align-content-center ps-2">
    <div class="mx-2 user-name" [appTruncateText]="!isDependent() ? 20 : 100">
      {{userInfo().name}}
    </div>
    @if(!isDependent()){
      @if (userRank) {
      <div class="mx-2 user-score">
        Rank: {{userRank}} <i class="bi bi-dot"></i>
        <span>{{userScore}} pontos</span>
      </div>
      } @else {
      <div class="mx-2 user-score">
        Ainda não tem Ranking
      </div>
      }
    }

  </div>

  <div class="dropdown">
    <!--  Visão desktop: Mostra do md pra cima -->
    <div class="d-none d-md-block user-img me-2 dropdown-toggle  no-icon" type="button" data-bs-toggle="dropdown" aria-expanded="false">
      <!-- <img [src]="userPhoto" alt="User image"> -->
      <i class="bi bi-list icons"></i>
    </div>

    <app-user-actions class="dropdown-menu" [isDependent]="isDependent()" [userBlocked]="userBlocked()"></app-user-actions>
  </div>
</div>
